<template>
<div class="information qualityenterprise">
	<leftnav class="fl" mkcode="B"  :title="curWebsite.type== 4?'市场情报动态':'招商情报动态'" itemcode="B-DTJC"></leftnav> 
	<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
		<govheader></govheader>
		<div class="index_left_centerpage">
			<div class="whitebox right_topbox" style="padding-bottom: 1px;">
						<div class="right_boxtitle">
							<span class="fl right_title">动态监测</span> 
						</div> 
				 <div class="opport-screen-list1"> 
					<dynamicNav tabCode="zsqb"></dynamicNav> 
					<dl class="opport-screen bdbe">
						<dt class="fl">时间</dt>
						<dd class="fl">
							<span v-for="(item,index) in dayarry" @click="daychoose(item.key);" :class="timekey == item.key?'a-screen current':'a-screen'">{{item.name}}</span>
						</dd>
					</dl> 
				<dl class="opport-screen bdbe" >
					<dt class="fl">产业分类</dt>
					<dd class="fl ">
						<span v-for="item in meunlist" :class="notioncode==item.notioncode?' a-screen current' :'a-screen'" @click="menutoggle(item)">{{item.notion}}</span> 
					</dd>
				</dl>
				<dl class="opport-screen bdbe" >
					<dt class="fl">关键词 </dt> 
					<dd class="fl ">
						<span :class="keyid == '' ?' a-screen current' :'a-screen'" @click="keycodetoggle('')">全部</span>
						<span v-for="item in commonkeylist" :class="keyid == item.id ?' a-screen current' :'a-screen'" @click="keycodetoggle(item.id)">{{item.name}}</span> 
					</dd>
				</dl>
				</div>
			</div>
		<div class="whitebox">  
		<div class="enterparise_guide oh" style="width: 95%; ">
			<p class="fl">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
			<!-- <p class="fl"   v-if="kwtextsearch">产业大脑为您找到<span 	class="searchnum">{{total}}</span>条【 <span class="orangefont">{{kwtextsearchtext}}</span>】条相关招商情报动态</p> -->
		</div>
		<div class="information_content information_box">
			<div class="infornews" v-for="list in listdata" >
				<div @click="routerlinkid('/news',list.id,2)" class="infornews_d">
					<h5 class="title"><span class="fl info_title">{{list.title}}</span><span class="fr">{{list.publishTime}}</span></h5>
					<p>{{list.summary}}</p>
				</div>  
				<div class="keywords" v-show="list.keylist.length>0">
					<span v-for="item in list.keylist" @click="tagrouter('/timeinforKey',7,'news',item.id,item.name)">{{item.name}}</span>
				</div>
			</div> 
		</div>
		<div class="centerpage1 company_pagelist" v-show="totalPage>1">
			<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
		</div> 
		</div>
		</div>
	</div>
</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
	  name: 'timefor',
	  computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
			data(){return{ 
				userdata:{},curWebsite:this.$api.getWebsiteType(),  title:"招商情报动态",notioncode:'',searchtype:4,
				meunlist:[
					{notion:'全部',notioncode:''},
					{notion:'高端装备',notioncode:'A01'},
					{notion:'汽车产业',notioncode:'A02'},
					{notion:'新一代信息技术',notioncode:'A03'},
					{notion:'新材料',notioncode:'A04'},
					{notion:'新能源',notioncode:'A05'},
					{notion:'生物医药',notioncode:'A06'},
					{notion:'环保',notioncode:'A07'}, ],
				meunindex:0,commonkeylist:[], 
				enterpriseOption:[],
				dayarry:[{name:"近一月",key:"month"},{name:'近一周',key:"week"},{name:"本日",key:"day"}],
				stockChiness:'全部', searchstockCode:'all',
				timekey:'month', 
				keyid:'',
				listdata:[],
				page: 1, //显示的是哪一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数
			}},
			created(){  
					this.$nextTick(() => {
							// 禁用右键
							document.oncontextmenu = new Function("event.returnValue=false");
							// 禁用选择
							document.onselectstart = new Function("event.returnValue=false");
					}); 
				this.userdata =this.getuseriformation(); 
			},
			mounted() { 
				document.getElementById('app').style.background = "#f0f3f5";
				this.bus.$emit('loading', true);
				if(this.userdata.edition<1){
					var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
					setTimeout(function(){
						_this.routerself('/totalEnterprises');
					},1000)
					return;
				}
				this.getlist();
				this.getcomkeycode();
			},
		
			methods: {
				//时间筛选
				daychoose(key){
					this.timekey=key;
					this.getlist();
				},
				menutoggle(data){
					this.notioncode=data.notioncode;
					this.getlist();
				},
				keycodetoggle(id){
					this.keyid=id;
					this.getlist();
				},
			 getlist(page){
					this.bus.$emit('loading', false);
					// console.log(notioncode); 
					this.page=page?page:1;
			 	var _this = this; 
					var keywja=this.splicing('keywords',this.keyid);
					var notionja=this.splicing('notionList',this.notioncode);
					var dateja=this.splicing('date',this.timekey);
			 	// this.bus.$emit('loading', true);
			 	var ajaxurl =this.$api.cyl.OCNNews.list()+'?page='+this.page+ keywja+notionja+dateja;  
					console.log(ajaxurl);
			 	this.$axios.get(ajaxurl, {
			 		headers: {
			 			AuthToken: this.userdata.token
			 		}
			 	}).then(function(res) {
			 		// console.log(res.data);
			 		if (res.data.success) { 
							_this.listdata = res.data.list;
							for(var i=0;i<res.data.list.length;i++){
								_this.listdata[i].keylist=_this.taglistfun(res.data.list[i].keywordsText,res.data.list[i].keywords);
							}
							console.log(_this.listdata)
							_this.bus.$emit('loading', false);
							_this.totalPage = res.data.totalPage;
							_this.pageSize = res.data.pageSize;
							_this.total = res.data.totalRecord; 
			 		} else {
			 			
			 		}
			 	}).catch(function(error) {
			 		_this.bus.$emit('loading', false);
			 		// 请求失败处理 console.log(error);
			 	});
			 }, 
				getcomkeycode(){
					var ajaxurl =this.$api.cyl.OCNNews.keywords();  
					var _this = this; 
					this.$axios.get(ajaxurl, {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {
						// console.log(res.data);
						console.log('getcomkeycode',res.data)
						if (res.data.success) {   
							_this.commonkeylist=res.data.list;
							_this.bus.$emit('loading', false); 
						} else {
							
						}
					}).catch(function(error) {
						_this.bus.$emit('loading', false);
						// 请求失败处理 console.log(error);
					});
					
					
				},
			pageHandler: function(page) {
				// this.page = page;
				this.getlist(page);
			},
				
				
			},
	}
</script>

<style>
</style>
